import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import { logout } from '@/core/actions/auth';

Vue.use(VueRouter);

const routes: RouteConfig[] = [
  {
    name: 'sso',
    path: '/sso',
    props: () => ({
      sso: true,
    }),
    component: () => import('@/routes/LoginRoute.vue'),
  },
  {
    name: 'logout',
    path: '/logout',
    beforeEnter: (to, from, next) => {
      logout();
      next({ name: 'home' });
    },
  },
  {
    name: 'signup-developer',
    path: '/signup/developer',
    props: () => ({ isDeveloper: true }),
    component: () => import('@/routes/SignUpRoute.vue'),
  },
  {
    name: 'signup',
    path: '/signup',
    component: () => import('@/routes/SignUpRoute.vue'),
  },
  {
    name: 'verify',
    path: '/verify/:userId?',
    props: true,
    component: () => import('@/routes/InvitedAuthRoute.vue'),
  },
  {
    name: 'password-reset',
    path: '/password/reset',
    props (route) {
      return {
        email: route.query.email ? route.query.email : '',
      };
    },
    component: () => import('@/routes/PasswordResetRoute.vue'),
  },
  {
    name: 'password-change',
    path: '/password/change',
    props (route) {
      return {
        email: route.query.email,
        token: route.query.token,
      };
    },
    component: () => import('@/routes/PasswordChangeRoute.vue'),
  },
  {
    name: 'home',
    path: '*',
    component: () => import('@/routes/LoginRoute.vue'),
    beforeEnter (to, from, next) {
      if (to.query.validationKey) {
        next({ ...to, name: 'verify' });
        return;
      }
      next();
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;

export function useRouter (): VueRouter {
  return router;
}
